import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "statusFilter", "sortSelect", "container", "card", "emptyState"]
  
  connect() {
    this.filter()
  }
  
  filter() {
    const searchTerm = this.searchInputTarget.value.toLowerCase()
    const statusFilter = this.statusFilterTarget.value
    let visibleCount = 0
    
    this.cardTargets.forEach(card => {
      const name = card.dataset.name || ""
      const status = card.dataset.status || ""
      
      const matchesSearch = searchTerm === "" || name.includes(searchTerm)
      const matchesStatus = statusFilter === "" || status === statusFilter
      
      if (matchesSearch && matchesStatus) {
        card.classList.remove("hidden")
        visibleCount++
      } else {
        card.classList.add("hidden")
      }
    })
    
    // Empty State anzeigen wenn keine Ergebnisse
    if (this.hasEmptyStateTarget) {
      if (visibleCount === 0) {
        this.emptyStateTarget.classList.remove("hidden")
      } else {
        this.emptyStateTarget.classList.add("hidden")
      }
    }
    
    // Nach dem Filtern auch sortieren
    this.sort()
  }
  
  sort() {
    const sortValue = this.sortSelectTarget.value
    const cards = Array.from(this.cardTargets)
    
    cards.sort((a, b) => {
      switch(sortValue) {
        case "created_at_desc":
          return parseInt(b.dataset.createdAt) - parseInt(a.dataset.createdAt)
        case "created_at_asc":
          return parseInt(a.dataset.createdAt) - parseInt(b.dataset.createdAt)
        case "name_asc":
          return (a.dataset.name || "").localeCompare(b.dataset.name || "")
        case "name_desc":
          return (b.dataset.name || "").localeCompare(a.dataset.name || "")
        default:
          return 0
      }
    })
    
    // Cards in neuer Reihenfolge anzeigen
    cards.forEach(card => {
      this.containerTarget.appendChild(card)
    })
  }
}

